export interface ReportFilterData {
  warengruppen: [];
  lieferantenNummern?: [];
  articlesMarkerNames: string[];
  modelMarkerNames: string[];
  lieferantenNummer: number;
  responsibleNames: string[];

  name: string;
  title: string;
  isMaintained: boolean | null;
  reportType: string;
  sort: string;

  IsOneFileForSelectedSuppliers: boolean;
  isOutputID: boolean;
  isMitglied: boolean;
  isPdf: boolean;
  numberCopies: string;
  quantityCopies: string;
  zrMitglied: string;
}

function defaultData(): ReportFilterData {
  return {
    warengruppen: [],
    lieferantenNummern: [],
    articlesMarkerNames: [],
    modelMarkerNames: [],
    lieferantenNummer: 0,
    responsibleNames: [],

    name: '',
    title: '',
    isMaintained: null,
    reportType: '',
    sort: '',

    IsOneFileForSelectedSuppliers: false,
    isOutputID: false,
    isMitglied: false,
    isPdf: true,
    numberCopies: '1',
    quantityCopies: '1',
    zrMitglied: '',
  };
}

export default {
  defaultData,
};
